export var TradeStatus;
(function (TradeStatus) {
    TradeStatus[TradeStatus["Initializing"] = 0] = "Initializing";
    TradeStatus[TradeStatus["WaitingToDeposit"] = 1] = "WaitingToDeposit";
    TradeStatus[TradeStatus["WaitingToClaim"] = 2] = "WaitingToClaim";
    TradeStatus[TradeStatus["Closed"] = 3] = "Closed";
    TradeStatus[TradeStatus["Canceling"] = 100] = "Canceling";
    TradeStatus[TradeStatus["Canceled"] = 101] = "Canceled";
})(TradeStatus || (TradeStatus = {}));
export var ItemStatus;
(function (ItemStatus) {
    ItemStatus[ItemStatus["NFTPending"] = 10] = "NFTPending";
    ItemStatus[ItemStatus["SolPending"] = 11] = "SolPending";
    ItemStatus[ItemStatus["NFTDeposited"] = 20] = "NFTDeposited";
    ItemStatus[ItemStatus["SolDeposited"] = 21] = "SolDeposited";
    ItemStatus[ItemStatus["SolToClaim"] = 22] = "SolToClaim";
    ItemStatus[ItemStatus["NFTClaimed"] = 30] = "NFTClaimed";
    ItemStatus[ItemStatus["SolClaimed"] = 31] = "SolClaimed";
    ItemStatus[ItemStatus["NFTcanceled"] = 100] = "NFTcanceled";
    ItemStatus[ItemStatus["Solcanceled"] = 101] = "Solcanceled";
    ItemStatus[ItemStatus["NFTcanceledRecovered"] = 110] = "NFTcanceledRecovered";
    ItemStatus[ItemStatus["SolcanceledRecovered"] = 111] = "SolcanceledRecovered";
})(ItemStatus || (ItemStatus = {}));
